import { HistoryOptions } from "@hakit/core";

export function DummyComponentHistoryOptions(props: Partial<HistoryOptions>) {
  return props;
}
